import React from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";

// styling

import screenSize from "utils/screenSize";
import { CollapsedSearchResult } from "../new-book-a-course/CourseListStyle";

import { ContentSection } from "../new-book-a-course/BookACourseStyle";

const { Panel } = Collapse;

type CourseListProps = {
  courseList: any[];
  loadingCourseList: boolean;
};

const CourseList = ({ courseList, loadingCourseList }: CourseListProps) => {
  const parsedCourseDescription = (courseDescription: string) => {
    const removedCourseName = courseDescription.split("/")[0];
    const removeSpecialCharactor = removedCourseName.replace(/[\][]/g, "");
    const removeCourseLevel = `${removeSpecialCharactor.split("·")[1]}-${
      removeSpecialCharactor.split("·")[2]
    }-${removeSpecialCharactor.split("·")[3]}`;
    const startEndOnly = `${removeSpecialCharactor.split("·")[2]}-${
      removeSpecialCharactor.split("·")[3]
    }`;
    if (screenSize() !== "mobile") {
      return <span>{removeCourseLevel} </span>;
    }

    return (
      <span>
        <span> {removeSpecialCharactor.split("·")[1]} </span>
        <div style={{ paddingLeft: "35px" }}>{startEndOnly.trim()}</div>
      </span>
    );
  };

  if (loadingCourseList) return <p>Loading ....</p>;
  if (courseList.length === 0)
    return (
      <p>
        There are no Intensive Courses on weekends. Choose a Standard Course
        instead
      </p>
    );
  return (
    <ContentSection>
      <CollapsedSearchResult
        bordered={false}
        expandIcon={() => <CaretRightOutlined />}
      >
        {courseList.map((course: { description: string; id: number }) => (
          <Panel
            header={parsedCourseDescription(course.description)}
            key={course.id}
          />
        ))}
      </CollapsedSearchResult>
    </ContentSection>
  );
};

export default CourseList;
